import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import moment from 'moment';

import ExchangeRate from 'components/pages/sfms/dashboard/main/ExchangeRate';
import Export from 'components/pages/sfms/dashboard/main/Export';
import Link from 'components/pages/sfms/dashboard/main/Link';
import Notice from 'components/pages/sfms/dashboard/main/Notice';
import RawMaterial from 'components/pages/sfms/dashboard/main/RawMaterial';

/**
 * 대시보드 > 메인 대시보드
 */
const Content = () => {
  /* state */
  // 선택한 월
  const [date, setDate] = useState(
    moment()
      .add(moment().date() >= 22 ? 1 : 0, 'months')
      .format('YYYYMM')
  );

  return (
    <>
      <ExchangeRate date={date} setDate={setDate} />
      <RawMaterial date={date} />
      <Row xxl={2} className="mb-3">
        <Col>
          <Export date={date} />
        </Col>
        <Col>
          <Notice />
        </Col>
      </Row>
      <Link />
      <p className="position-absolute bottom-0 fs--1 text-600 mb-4">
        2022 © Sunjin Formulation Management System
      </p>
    </>
  );
};

export default Content;
